import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ExcluirContato } from './types';

export const INITIAL_STATE: ExcluirContato = {
	status: 0,
	form: { id: 0 },
};

export default function alteraEnderecoCartao(
	state = INITIAL_STATE,
	action: ReducerAction,
): ExcluirContato {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_CONTRATO_REQUEST: {
				draft.form = action.payload;
				break;
			}

			case Types.EXCLUIR_CONTRATO_SUCCESS: {
				draft.status = 200;
				break;
			}

			case Types.EXCLUIR_CONTRATO_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.LIMPAR_EXCLUIR_CONTRATO: {
				draft.status = 0;
				break;
			}

			default:
		}
	});
}
